import React from "react";
import {
    LineChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";

const data = [
    { name: "Jan", sales: 400, profit: 240 },
    { name: "Feb", sales: 300, profit: 139 },
    { name: "Mar", sales: 200, profit: 980 },
    { name: "Apr", sales: 278, profit: 390 },
    { name: "May", sales: 189, profit: 480 },
];

const CustomChartCard = () => {
    return (
        <div className="row pb-3">
            <div className="chart-content-bg">
                <div className="col-12 col-sm-6 col-md-6 col-lg-12 mt-2">
                    <div className="card">
                        <div className="card-body w-100">
                            <div className="d-flex justify-content-center">
                                <div style={{ width: "100%", height: 300 }}>
                                    <ResponsiveContainer>
                                        <LineChart data={data}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="sales" fill="#8884d8" />
                                            <Line type="monotone" dataKey="profit" stroke="#82ca9d" />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default CustomChartCard;
